// @ts-nocheck
import styled from 'styled-components';

interface BoxStyledProps {
  bg?: string;
  sx?: object;
  m?: number;
  mt?: number;
  mr?: number;
  ml?: number;
  mb?: number;
  mx?: number;
  my?: number;
  p?: number;
  pt?: number;
  pr?: number;
  pl?: number;
  pb?: number;
  px?: number;
  py?: number;
}
// TODO:
// 1. Create a mapper function which coverts css tokens to css properties
// (m, p, mt ...etc) => m === 'margin', mt=== 'marginTop'
// 2. Create a function which construct css object (based on component tokens: Example {m: 2})
const propsMapper = {
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'margin-x',
  my: 'margin-y',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pl: 'paddingLeft',
  pb: 'paddingBottom',
  px: 'padding-x',
  py: 'padding-y',
};

const getShorthandProps = (componentProps, shorthandKeys) => {
  return Object.keys(componentProps).reduce((acc, key) => {
    if (shorthandKeys.includes(key)) {
      return {
        ...acc,
        [key]: componentProps[key],
      };
    }

    return acc;
  }, {});
};

// TODO: alex write test for it
const mapShortenedProps = (componentProps, theme) => {
  return Object.keys(componentProps).reduce((acc, key) => {
    if (key === 'mx') {
      acc[propsMapper.mr] = `${theme.space[componentProps[key]]}`;
      acc[propsMapper.ml] = `${theme.space[componentProps[key]]}`;
    } else if (key === 'my') {
      acc[propsMapper.mt] = `${theme.space[componentProps[key]]}`;
      acc[propsMapper.mb] = `${theme.space[componentProps[key]]}`;
    } else if (key === 'px') {
      acc[propsMapper.pl] = `${theme.space[componentProps[key]]}`;
      acc[propsMapper.pr] = `${theme.space[componentProps[key]]}`;
    } else if (key === 'py') {
      acc[propsMapper.pt] = `${theme.space[componentProps[key]]}`;
      acc[propsMapper.pb] = `${theme.space[componentProps[key]]}`;
    } else {
      acc[propsMapper[key]] = `${theme.space[componentProps[key]]}`;
    }

    return acc;
  }, {});
};

const BoxStyled = styled.div<BoxStyledProps>(
  ({ theme, bg, sx, ...restProps }) => {
    const shorthandProps = getShorthandProps(
      restProps,
      Object.keys(propsMapper),
    );

    let styleSheet = {
      boxSizing: 'border-box',
      ...mapShortenedProps(shorthandProps, theme),
    };

    if (bg) {
      styleSheet.background = bg;
    }

    styleSheet = {
      ...styleSheet,
      ...sx,
    };

    return styleSheet;
  },
);

export { BoxStyled };
